import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PassengerCounters from '../../../../components/flights/passengerCounters/PassengerCounters';
import Constants from '../../../../model/AppConfiguration';
import { AppBar, Typography, withStyles } from 'material-ui';
import Tabs, { Tab } from 'material-ui/Tabs';
import PassengersCounterTabStyles from './PassengersCounterTabStyles';
import PassengersCounterTabsStyles from './PassengersCounterTabsStyles';
import PlaneIcon from '../../../../icons/PlaneIcon';
import ClassNames from 'classnames';
import Dictionary from '../../../../model/Dictionary';
import ColorPalette from '../../../../components/styling/ColorPalette';
import FlightsScreenController from '../../FlightsScreenController';
import StyledComponent from '../../../../components/styling/StyledComponent';
import '../../../routeTabs/RouteTabs.css';

function TabContainer (props) {
  return (
    <Typography
      component='div'
      style={{ padding: 8 * 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = { children: PropTypes.node.isRequired };

class PassengersCounterTabs extends Component {
  generateTabName = (route, selectedTab, isRouteActive, isArrival) => {
    const { flights } = this.props;
    let departure = isArrival ? route.arrival.slice(0, 3) : route.departure.slice(0, 3);
    let arrival = isArrival ? route.departure.slice(0, 3) : route.arrival.slice(0, 3);
    let departureDate =
      flights[ 0 ] && flights[ 0 ].date ? flights[ 0 ].date : Dictionary.flights.selectDate;
    let arrivalDate =
      flights[ 1 ] && flights[ 1 ].date ? flights[ 1 ].date : Dictionary.flights.selectDate;
    let selectedDate = isArrival ? arrivalDate : departureDate;
    selectedDate = FlightsScreenController.formatDateLongMonthWithDay(selectedDate);

    return (
      <span className='tab-icon-text-wrapper'>
        <span className='route-name'>
          {departure}
          &nbsp;&nbsp;
          <PlaneIcon
            className={ClassNames({
              'plane-selected': isRouteActive,
              'plane-default': !isRouteActive,
            })}
          />&nbsp;
          {arrival}
          <div className='route-date'>{selectedDate}</div>
        </span>
      </span>
    );
  };

  render () {
    const {
      selectedRoute,
      selectedTrip,
      changePassengerNumber,
      handleTabChange,
      selectedTab,
      flights,
      classes,
    } = this.props;

    let tab = selectedTrip && selectedTrip.id === Constants.flights.roundTrip ? selectedTab : 0;
    let currentlyActiveRoute = selectedRoute ? parseInt(selectedRoute.id, 10) - 1 : '';
    let isRouteActive = currentlyActiveRoute === tab;
    let tab1 = this.generateTabName(selectedRoute, tab, isRouteActive);
    let tab2 = this.generateTabName(selectedRoute, tab, !isRouteActive, true);
    let isRoundTrip = selectedTrip && selectedTrip.id === Constants.flights.roundTrip;
    const StyledTabs = StyledComponent(Tabs)(PassengersCounterTabsStyles);

    return (
      <div>
        <AppBar
          position='static'
          style={{
            backgroundColor: ColorPalette.navigationBgBlue,
            borderRadius: 0,
            width: '100%',
            boxShadow: 'none',
          }}
        >
          <StyledTabs
            value={tab}
            onChange={handleTabChange}
            indicatorColor='none'
            textColor='primary'
            centered
            fullWidth
          >
            <Tab
              label={tab1}
              classes={classes}
              style={{ minWidth: isRoundTrip ? 'inherit' : 'calc(100% - 5px)' }}
            />
            {isRoundTrip ? <Tab label={tab2} classes={classes} /> : null}
          </StyledTabs>
        </AppBar>
        {flights.map((flight, index) => {
          if (
            tab !== index ||
            (selectedTrip && selectedTrip.id === Constants.flights.oneWay && index > 0)
          ) {
            return null;
          }
          return (
            <TabContainer key={`passenger-counter-tab-${flight.id}-${index}`}>
              <PassengerCounters
                flightId={flight.id}
                adults={flight.adults}
                infants={flight.infants}
                sufix={index === 0 ? 'Departure' : ''}
                changePassengerNumber={changePassengerNumber}
              />
            </TabContainer>
          );
        })}
      </div>
    );
  }
}

PassengersCounterTabs.propTypes = {
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  flights: PropTypes.arrayOf(PropTypes.object),
  changePassengerNumber: PropTypes.func,
  selectedTab: PropTypes.number,
  handleTabChange: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(PassengersCounterTabStyles)(PassengersCounterTabs);



// WEBPACK FOOTER //
// ./src/containers/flights/common/passengersCounter/PassengersCounterTabs.js